import { ILiftNewsFeeds } from '@llws/lift-entity-interfaces';
import { Equal, IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/client-api/lift_news_feeds';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {
  alias: 'um',
  orderBy: [{ field: 'publishDate', direction: 'desc' }],
  limit: 999,
  where: [
    Equal('status', 'enabled'),
  ],
  relations: [
    {
      path: 'um.liftNewsFeeds2Clients',
      alias: 'liftNewsFeeds2Clients',
    },
  ],
};
const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<ILiftNewsFeeds>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'lift-news-feed/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
